// extracted by mini-css-extract-plugin
export default {"wrapper":"RequestStopsDetails_wrapper__Sh2fF","wrapper__bar":"RequestStopsDetails_wrapper__bar__6R-hq"};